import React from 'react'
import CaptureImage from './CaptureImage'

export default function CustomerPhoto({ src, skipped = false }) {
  return (
    <section aria-label="Customer Photo" className="rounded-xl border border-border/60 p-4 break-inside-avoid">
      <h2 className="text-sm font-semibold text-foreground mb-3">Customer Photo</h2>
      {src ? (
        <CaptureImage
          src={src}
          alt="Customer photo"
          className="mx-auto max-h-72 w-full rounded-lg border border-border/60 object-contain bg-white"
        />
      ) : (
        <p className="text-sm text-foreground">
          {skipped ? 'Customer photo was skipped during capture.' : 'No customer photo is saved with this transaction.'}
        </p>
      )}
    </section>
  )
}
